module.exports = __webpack_public_path__ + "img/default4.a4f61fae.jpg";